import { createFileRoute, type ErrorComponentProps } from "@tanstack/react-router";
import { CmsRouteView } from "@/components/cms/CmsRouteView";
import { publishedCmsPageQuery } from "@/lib/cms/queries";
import { canonicalUrl } from "@/lib/seo/site";

export const Route = createFileRoute("/faq")({
  head: () => ({ meta: [
    { title: "Frequently Asked Questions — CB16 Atelier" },
    { name: "description", content: "Answers to the most common questions about CB16 fragrances, orders and services." },
    { property: "og:title", content: "CB16 FAQ" },
    { property: "og:description", content: "Answers to the most common questions about CB16 fragrances, orders and services." },
    { property: "og:type", content: "website" },
    { name: "twitter:card", content: "summary" },
    { property: "og:url", content: canonicalUrl("/faq") },
  ], links: [{ rel: "canonical", href: canonicalUrl("/faq") }] }),
  loader: ({ context }) => context.queryClient.ensureQueryData(publishedCmsPageQuery("faq")),
  errorComponent: ({ error }: ErrorComponentProps) => (
    <div role="alert" className="mx-auto max-w-3xl px-6 py-24 text-center text-sm text-black/60">
      {error instanceof Error ? error.message : "Something went wrong."}
    </div>
  ),
  notFoundComponent: () => (
    <div className="mx-auto max-w-3xl px-6 py-24 text-center text-sm text-black/60">Page not found.</div>
  ),
  component: () => <CmsRouteView slug="faq" fallbackTitle="Frequently asked questions" />,
});